import { setTimeout, assign, ONE_MINUTE } from '@openobserve/browser-core';
import { trackFirstContentfulPaint } from './trackFirstContentfulPaint';
import { trackFirstInputTimings } from './trackFirstInputTimings';
import { trackNavigationTimings } from './trackNavigationTimings';
import { trackLargestContentfulPaint } from './trackLargestContentfulPaint';
/**
 * The initial view can finish quickly, before some metrics can be produced (ex: before the page load
 * event, or the first input). Also, we don't want to trigger a view update indefinitely, to avoid
 * updates on views that ended a long time ago. Keep watching for metrics after the view ends for a
 * limited amount of time.
 */
export var KEEP_TRACKING_METRICS_AFTER_VIEW_DELAY = 5 * ONE_MINUTE;
export function trackInitialViewMetrics(lifeCycle, configuration, webVitalTelemetryDebug, setLoadEvent, scheduleViewUpdate) {
    var initialViewMetrics = {};
    function setMetrics(newMetrics) {
        assign(initialViewMetrics, newMetrics);
        scheduleViewUpdate();
    }
    var stopNavigationTracking = trackNavigationTimings(lifeCycle, function (navigationTimings) {
        setLoadEvent(navigationTimings.loadEvent);
        setMetrics(navigationTimings);
    }).stop;
    var stopFCPTracking = trackFirstContentfulPaint(lifeCycle, configuration, function (firstContentfulPaint) {
        return setMetrics({ firstContentfulPaint: firstContentfulPaint });
    }).stop;
    var stopLCPTracking = trackLargestContentfulPaint(lifeCycle, configuration, window, function (largestContentfulPaint, lcpElement) {
        webVitalTelemetryDebug.addWebVitalTelemetryDebug('LCP', lcpElement, largestContentfulPaint);
        setMetrics({
            largestContentfulPaint: largestContentfulPaint,
        });
    }).stop;
    var stopFIDTracking = trackFirstInputTimings(lifeCycle, configuration, function (_a) {
        var firstInputDelay = _a.firstInputDelay, firstInputTime = _a.firstInputTime, firstInputTarget = _a.firstInputTarget;
        webVitalTelemetryDebug.addWebVitalTelemetryDebug('FID', firstInputTarget, firstInputTime);
        setMetrics({
            firstInputDelay: firstInputDelay,
            firstInputTime: firstInputTime,
        });
    }).stop;
    function stop() {
        stopNavigationTracking();
        stopFCPTracking();
        stopLCPTracking();
        stopFIDTracking();
    }
    return {
        stop: stop,
        initialViewMetrics: initialViewMetrics,
        scheduleStop: function () {
            setTimeout(stop, KEEP_TRACKING_METRICS_AFTER_VIEW_DELAY);
        },
    };
}
//# sourceMappingURL=trackInitialViewMetrics.js.map